import React, { Component } from "react"

class Label extends Component {
  render() {
    return(
      <div className={`table rounded-lg bg-orange text-white px-4 py-2 text-xs font-semibold ${this.props.style}`}>
        {this.props.children}
      </div>
    );
  }
}
export default Label
